var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "Loading",
            {
              attrs: {
                visible: _vm.loading,
                message: "Caricamento lavorazione...",
                templateType: _vm.loadTemplateCorrente,
              },
            },
            [
              _c(
                "div",
                [
                  _vm.lavorazione && _vm.lavorazione != null
                    ? _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "offset-xs1": "" } },
                            [
                              _c(
                                "v-card",
                                [
                                  _c("v-progress-linear", {
                                    staticStyle: { margin: "0" },
                                    attrs: {
                                      color:
                                        _vm.lavorazione.progresso < 100
                                          ? "info"
                                          : "success",
                                      height: "5",
                                      value: _vm.lavorazione.progresso,
                                    },
                                  }),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs8: "" } },
                                            [
                                              _c(
                                                "h3",
                                                {
                                                  staticClass: "headline mb-0",
                                                  attrs: {
                                                    "data-test":
                                                      "lavorazione-codiceLAK",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.lavorazione
                                                          .codiceLAK
                                                      ) +
                                                      " "
                                                  ),
                                                  _vm.lavorazione.firstCost ==
                                                  "S"
                                                    ? _c("span", [
                                                        _vm._v(" USA"),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _c("div", [
                                                _vm._v("STAGIONE: "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.lavorazione
                                                        .stagioneDecodificata.id
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.lavorazione
                                                          .stagioneDecodificata
                                                          .descrizione
                                                      )
                                                  ),
                                                ]),
                                              ]),
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: "ordine",
                                                      params: {
                                                        id: _vm.lavorazione
                                                          .innerLavorazione
                                                          .idLampft,
                                                      },
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v("ORDINE NR: "),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.lavorazione
                                                            .innerLavorazione
                                                            .ordineNumero
                                                        ) +
                                                          " / " +
                                                          _vm._s(
                                                            _vm.lavorazione
                                                              .innerLavorazione
                                                              .ordineLinea
                                                          ) +
                                                          " del " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatDate"
                                                            )(
                                                              _vm.lavorazione
                                                                .dataOrdine
                                                            )
                                                          )
                                                      ),
                                                    ]),
                                                  ]),
                                                ]
                                              ),
                                              _c("div", [
                                                _vm._v("LOTTO: "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.lavorazione.lotto
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" CONSEGNA: "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.lavorazione
                                                        .codiceConsegna
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                              _c("div", [
                                                _vm._v("DATA SCADENZA: "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("formatDate")(
                                                        _vm.lavorazione
                                                          .dataConsegna
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.lavorazione.campionario
                                                      ? "CAMPIONARIO"
                                                      : "PRODUZIONE"
                                                  )
                                                ),
                                                _vm.lavorazione.firstCost == "S"
                                                  ? _c("span", [
                                                      _c("strong", [
                                                        _vm._v(" USA"),
                                                      ]),
                                                    ])
                                                  : _vm._e(),
                                              ]),
                                              _c("br"),
                                              _vm.lavorazione
                                                .lineaVenditaDecodificata
                                                ? _c("div", [
                                                    _vm._v(
                                                      "LINEA DI VENDITA: "
                                                    ),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.lavorazione
                                                            .lineaVenditaDecodificata
                                                            .id
                                                        ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.lavorazione
                                                              .lineaVenditaDecodificata
                                                              .descrizione
                                                          )
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                              _c("div", [
                                                _vm._v("MODELLO: "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.lavorazione
                                                        .modelloDecodificato
                                                        .codiceParte
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.lavorazione
                                                          .modelloDecodificato
                                                          .descrizione
                                                      )
                                                  ),
                                                ]),
                                              ]),
                                              _c("div", [
                                                _vm._v("FASE: "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.lavorazione
                                                        .faseDecodificata.id
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.lavorazione
                                                          .faseDecodificata
                                                          .descrizione
                                                      )
                                                  ),
                                                ]),
                                              ]),
                                              _c("div", [
                                                _vm._v("COLORE: "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.lavorazione
                                                        .coloreDecodificato
                                                        .codiceColore
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.lavorazione
                                                          .coloreDecodificato
                                                          .descrizione
                                                      )
                                                  ),
                                                ]),
                                              ]),
                                              _c("div", [
                                                _vm._v("COMPONENTE CAPO: "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.lavorazione
                                                        .componenteCapo
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                              _vm.lavorazione.idOrdineMTM
                                                ? _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to: {
                                                          name: "ordine-mtm",
                                                          params: {
                                                            id: _vm.lavorazione
                                                              .idOrdineMTM,
                                                            idRiga:
                                                              _vm.lavorazione
                                                                .idRigaMTM,
                                                            idLavorazioneAssociata:
                                                              _vm.lavorazione
                                                                .id,
                                                          },
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v(
                                                          "ORDINE MTM: " +
                                                            _vm._s(
                                                              _vm.lavorazione
                                                                .idOrdineMTM
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.lavorazione.innerLavorazione
                                                .campionarietto
                                                ? _c("div", [
                                                    _vm._v("CAMPIONARIETTO: "),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.lavorazione
                                                            .innerLavorazione
                                                            .campionarietto
                                                        )
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                              _vm.lavorazione.innerLavorazione
                                                .riparazione
                                                ? _c("div", [
                                                    _vm._v("RIPARAZIONE: "),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.lavorazione
                                                            .innerLavorazione
                                                            .riparazione
                                                        )
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                              _vm.lavorazione.innerLavorazione
                                                .numeroLancio
                                                ? _c("div", [
                                                    _vm._v("NUMERO LANCIO: "),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.lavorazione
                                                            .innerLavorazione
                                                            .numeroLancio
                                                        )
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                              _vm.lavorazione.trattamentoStrong
                                                ? _c("div", [
                                                    _vm._v(
                                                      "TRATTAMENTO STRONG: "
                                                    ),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.lavorazione
                                                            .trattamentoStrong
                                                        )
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "10px",
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(" NOTE "),
                                                  ]),
                                                  _vm.lavorazione.note &&
                                                  _vm.lavorazione.note.length >
                                                    0 &&
                                                  !_vm.inModificaNote
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            border:
                                                              "1px solid gainsboro",
                                                            background:
                                                              "lightyellow",
                                                            padding: "5px",
                                                            "margin-left":
                                                              "5px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.lavorazione
                                                                .note
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.inModificaNote
                                                    ? _c(
                                                        "span",
                                                        [
                                                          _c("v-textarea", {
                                                            attrs: {
                                                              autofocus: "",
                                                              hint: "Note lavorazione",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.valoreNoteTemp,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.valoreNoteTemp =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "valoreNoteTemp",
                                                            },
                                                          }),
                                                          _c(
                                                            "v-card-actions",
                                                            [
                                                              _c("v-spacer"),
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "darken-1",
                                                                    text: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.inModificaNote = false
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Annulla"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "green darken-1",
                                                                    text: "",
                                                                    loading:
                                                                      _vm.loading,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.inviaModificaNote,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Salva"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  !_vm.inModificaNote
                                                    ? _c(
                                                        "span",
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                                ripple: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.modificaNote,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    small: "",
                                                                    color:
                                                                      "grey lighten-1",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-pencil"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "10px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticStyle: {
                                                        color: "white",
                                                        "margin-top": "10px",
                                                      },
                                                      attrs: {
                                                        loading:
                                                          _vm.xlsxPackingListLavorazioneLoading,
                                                        color: "blue lighten-2",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.downloadXLSXPackingListLavorazione,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Scarica XLSX Packing List Lavorazione "
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { right: "" },
                                                        },
                                                        [_vm._v("mdi-download")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-flex", { attrs: { xs4: "" } }, [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                              },
                                              [
                                                _c(
                                                  "h2",
                                                  {
                                                    staticStyle: {
                                                      "margin-bottom": "20px",
                                                      "item-aligns": "center",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          "vertical-align":
                                                            "middle",
                                                        },
                                                        attrs: {
                                                          large: "",
                                                          color:
                                                            "blue darken-2",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "statoLavorazioneIco"
                                                              )(
                                                                _vm.lavorazione
                                                                  .stato
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "statoLavorazioneDesc"
                                                            )(
                                                              _vm.lavorazione
                                                                .stato
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticStyle: {
                                                      width: "200px",
                                                    },
                                                    attrs: {
                                                      color: "primary",
                                                      disabled:
                                                        !_vm.azioniDisponibili,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.dialog = true
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" Azioni "),
                                                    _c(
                                                      "v-icon",
                                                      { attrs: { right: "" } },
                                                      [
                                                        _vm._v(
                                                          "mdi-cloud-upload"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-bottom-sheet",
                                                  {
                                                    attrs: { inset: "" },
                                                    model: {
                                                      value: _vm.dialog,
                                                      callback: function ($$v) {
                                                        _vm.dialog = $$v
                                                      },
                                                      expression: "dialog",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-card",
                                                      { attrs: { tile: "" } },
                                                      [
                                                        _c(
                                                          "WorkflowLavorazione",
                                                          {
                                                            on: {
                                                              "azione-inviata":
                                                                function (
                                                                  $event
                                                                ) {
                                                                  _vm.dialog = false
                                                                },
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.lavorazione.datiAggiuntivi &&
                          _vm.lavorazione.datiAggiuntivi.length > 0
                            ? _c(
                                "v-flex",
                                { attrs: { xs10: "", "offset-xs1": "" } },
                                [
                                  _c("v-card-title", [
                                    _c("h2", [_vm._v("Dati aggiuntivi")]),
                                  ]),
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticStyle: {
                                            color: "white",
                                            "margin-top": "15px",
                                            "margin-left": "24px",
                                            "margin-bottom": "5px",
                                          },
                                          attrs: { color: "green lighten-2" },
                                          on: { click: _vm.saveDatiAggiuntivi },
                                        },
                                        [
                                          _vm._v(" Salva dati "),
                                          _c(
                                            "v-icon",
                                            { attrs: { right: "" } },
                                            [_vm._v("mdi-content-save-outline")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-container",
                                        {
                                          attrs: {
                                            fluid: "",
                                            "grid-list-md": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            _vm._l(
                                              _vm.lavorazione.datiAggiuntivi,
                                              function (m, i) {
                                                return _c(
                                                  "v-flex",
                                                  {
                                                    key: m.name,
                                                    attrs: {
                                                      xs12: "",
                                                      sm6: "",
                                                      md4: "",
                                                    },
                                                  },
                                                  [
                                                    _c("CardEntityMetadata", {
                                                      attrs: {
                                                        entityMetadata: m,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "offset-xs1": "" } },
                            [
                              _c("v-card-title", [
                                _c("h2", [_vm._v("Progressi")]),
                              ]),
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-tabs",
                                    [
                                      _c("v-tab", [_vm._v(" lavorazione ")]),
                                      _c("v-tab", [_vm._v(" spedizione ")]),
                                      _c(
                                        "v-tab-item",
                                        [_c("ProgressoLavorazione")],
                                        1
                                      ),
                                      _c(
                                        "v-tab-item",
                                        [
                                          _c(
                                            "v-card",
                                            { attrs: { flat: "" } },
                                            [_c("ProgressoSpedizione")],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "offset-xs1": "" } },
                            [
                              _c("v-card-title", [
                                _c("h2", [_vm._v("Distinta")]),
                              ]),
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-tabs",
                                    [
                                      _c(
                                        "v-tab",
                                        {
                                          attrs: {
                                            "data-test":
                                              "distinta-dinamica-lavorazione-dettaglio",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " dinamica " +
                                              _vm._s(
                                                _vm.lavorazione
                                                  .distintaDinamica &&
                                                  _vm.lavorazione
                                                    .distintaDinamica
                                                    .righeDistintaDPC.length >=
                                                    0
                                                  ? `(${_vm.lavorazione.distintaDinamica.righeDistintaDPC.length})`
                                                  : ""
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-tab",
                                        {
                                          attrs: {
                                            "data-test":
                                              "distinta-statica-lavorazione-dettaglio",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " statica " +
                                              _vm._s(
                                                _vm.lavorazione
                                                  .distintaStatica &&
                                                  _vm.lavorazione
                                                    .distintaStatica
                                                    .righeDistintaDPC.length >=
                                                    0
                                                  ? `(${_vm.lavorazione.distintaStatica.righeDistintaDPC.length})`
                                                  : ""
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-tab-item",
                                        [
                                          !_vm.distintaDinamicaCaricata
                                            ? _c(
                                                "v-card-title",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        slot: "activator",
                                                        "data-test":
                                                          "btn-carica-distinta-dinamica",
                                                        color: "primary",
                                                        dark: "",
                                                        loading:
                                                          _vm.caricamentoDistinta,
                                                      },
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.caricaDistintaDinamica.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        },
                                                      },
                                                      slot: "activator",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Carica distinta dinamica "
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { right: "" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-format-list-numbered"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticStyle: {
                                                        color: "white",
                                                        "margin-top": "10px",
                                                        "margin-left": "24px",
                                                        "margin-bottom": "10px",
                                                      },
                                                      attrs: {
                                                        loading:
                                                          _vm.csvButtonLoading,
                                                        color:
                                                          "green lighten-2",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.downloadCSVDistinta,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(" Scarica CSV "),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { right: "" },
                                                        },
                                                        [_vm._v("mdi-download")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-data-table", {
                                                    staticClass: "elevation-1",
                                                    attrs: {
                                                      "data-test":
                                                        "tabella-distinta-dinamica",
                                                      items:
                                                        _vm.lavorazione
                                                          .distintaDinamica
                                                          .righeDistintaDPC,
                                                      headers: _vm.headers,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "item",
                                                          fn: function ({
                                                            item,
                                                          }) {
                                                            return [
                                                              _c(
                                                                "tr",
                                                                {
                                                                  class:
                                                                    _vm.classeRigaDistinta(
                                                                      item,
                                                                      true
                                                                    ),
                                                                  attrs: {
                                                                    "data-test":
                                                                      "distinta-dinamica",
                                                                  },
                                                                },
                                                                [
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.indiceRiga
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item
                                                                          .innerRigaDistinta
                                                                          .componente
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item
                                                                          .innerRigaDistinta
                                                                          .descri
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  item.coloreDecodificato
                                                                    ? _c("td", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item
                                                                              .coloreDecodificato
                                                                              .codiceColore
                                                                          ) +
                                                                            " " +
                                                                            _vm._s(
                                                                              item
                                                                                .coloreDecodificato
                                                                                .descrizione
                                                                            )
                                                                        ),
                                                                      ])
                                                                    : _c("td", [
                                                                        _vm._v(
                                                                          "-"
                                                                        ),
                                                                      ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item
                                                                          .innerRigaDistinta
                                                                          .unMisuraProd
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _c(
                                                                    "td",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "text-align":
                                                                            "end",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item
                                                                            .innerRigaDistinta
                                                                            .quantita
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item
                                                                          .innerRigaDistinta
                                                                          .partita
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item
                                                                          .innerRigaDistinta
                                                                          .utilizzo
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.contenitoreDecodificato
                                                                          ? item
                                                                              .contenitoreDecodificato
                                                                              .descrizione
                                                                          : ""
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      2238353306
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-tab-item",
                                        [
                                          !_vm.distintaStaticaCaricata
                                            ? _c(
                                                "v-card-title",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        slot: "activator",
                                                        "data-test":
                                                          "btn-carica-distinta-statica",
                                                        color: "primary",
                                                        dark: "",
                                                        loading:
                                                          _vm.caricamentoDistinta,
                                                      },
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.caricaDistintaStatica.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        },
                                                      },
                                                      slot: "activator",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Carica distinta statica "
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { right: "" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-format-list-numbered"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _c("v-data-table", {
                                                staticClass: "elevation-1",
                                                attrs: {
                                                  "data-test":
                                                    "tabella-distinta-statica",
                                                  items:
                                                    _vm.lavorazione
                                                      .distintaStatica
                                                      .righeDistintaDPC,
                                                  headers: _vm.headers,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    !_vm.$store.getters
                                                      .isUserAdmin
                                                      ? {
                                                          key: "top",
                                                          fn: function () {
                                                            return [
                                                              _c(
                                                                "v-card-title",
                                                                {
                                                                  staticClass:
                                                                    "justify-end",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "primary",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          _vm.vaiAComunicazioneConsumi,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Comunicazione consumi "
                                                                      ),
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              right:
                                                                                "",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-scissors-cutting"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        }
                                                      : null,
                                                    {
                                                      key: "item",
                                                      fn: function ({ item }) {
                                                        return [
                                                          _c(
                                                            "tr",
                                                            {
                                                              class:
                                                                _vm.classeRigaDistinta(
                                                                  item,
                                                                  false
                                                                ),
                                                              attrs: {
                                                                "data-test":
                                                                  "distinta-statica",
                                                              },
                                                            },
                                                            [
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.indiceRiga
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item
                                                                      .innerRigaDistinta
                                                                      .componente
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item
                                                                      .innerRigaDistinta
                                                                      .descri
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item
                                                                      .coloreDecodificato
                                                                      .codiceColore
                                                                  ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      item
                                                                        .coloreDecodificato
                                                                        .descrizione
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item
                                                                      .innerRigaDistinta
                                                                      .unMisuraDiBa
                                                                  )
                                                                ),
                                                              ]),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticStyle: {
                                                                    "text-align":
                                                                      "end",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatNumber"
                                                                      )(
                                                                        _vm.qtaCalcolataDaDibaStatica(
                                                                          item
                                                                        )
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "offset-xs1": "" } },
                            [
                              _c("v-card-title", [
                                _c("h2", [_vm._v("Righe correlate")]),
                              ]),
                              _c(
                                "v-card",
                                [
                                  _vm.lavorazione.lavorazioniCorrelate &&
                                  _vm.lavorazione.lavorazioniCorrelate.length ==
                                    0
                                    ? _c("v-card-text", [
                                        _vm._v("Nessuna riga correlata"),
                                      ])
                                    : _c("LavorazioniCards", {
                                        attrs: {
                                          lavorazioni:
                                            _vm.lavorazione
                                              .lavorazioniCorrelate,
                                        },
                                      }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", [
                        _vm._v(" OPPPSSS... Nessun dato da visualizzare. "),
                      ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }